import React from 'react';
import style from './style.module.css';
import { Button, Typography, Icon } from 'antd';

const { Title } = Typography;

const TitleAndNew2 = ({ titleText, buttonText, action }) => {
  return (
    <div className={style.wrapper}>
      <Title level={2}>{titleText}</Title>
      {buttonText && (
        <Button type="primary" onClick={action}>
          <Icon type="plus" />
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default TitleAndNew2;
